export default __webpack_public_path__ + "static/grid-gray-83259c679eb901d7bceafd52010246f8.svg";